var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-ueditor-wrap',{staticStyle:{"width":"90%"},attrs:{"config":_vm.myConfig},model:{value:(_vm.contents),callback:function ($$v) {_vm.contents=$$v},expression:"contents"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }